import { connect } from 'react-redux';
import Global from '../../../store/global-selectors';
import AddToBatchMenu from '../../../components/batches/add-to-batch-menu';
import { toggleBatchNavMenu, getBatchMenuData, loadMoreActiveBatches } from '../../../store/batches/nav/batches.nav.actions';
import { addFulfillmentPlansOrSalesOrderToBatchRequest, createBatchWithFulfillmentPlans } from '../../../store/batches/batches.actions';
import { getActualFulfillmentPlanIds, getActualSalesOrderIds } from '../../../store/orders/orders.helpers';
import { getBatchCollectionsFromState } from '../get-batch-collections-from-state';

const mapStateToProps = (state) => {
  const selectedIds = Global.selectSelectedOrdersIds(state);
  const actualSalesOrderIds = getActualSalesOrderIds(state, selectedIds);
  const actualFulfillmentPlanIds = getActualFulfillmentPlanIds(state, selectedIds);
  const areAllSelected = Global.selectSelectedOrdersAreAllOrdersSelected(state);
  const hasSelection = selectedIds.length > 0 || areAllSelected;
  const isOpen = Global.selectBatchesNavIsOpen(state);
  const users = Global.selectSellerUsers(state);
  const currentUserId = Global.selectUserCurrentUserId(state);
  const selectedUser = users.find((user) => user.userId === currentUserId);
  const isLoading = Global.selectBatchesNavIsLoading(state);
  const { myBatches } = getBatchCollectionsFromState(state);
  const totalBatchesCount = Global.selectBatchesNavTotalBatchesCount(state);
  const pageSize = Global.selectBatchesNavPageSize(state);
  const shouldShowLoadMoreButton = pageSize < totalBatchesCount;

  return {
    isOpen,
    isLoading,
    myBatches,
    totalBatchesCount,
    hasSelection,
    selectedGridIds: actualSalesOrderIds,
    assignedUser: selectedUser,
    selectedGridFulfillmentPlanIds: actualFulfillmentPlanIds,
    shouldShowLoadMoreButton,
  };
};

const mapDispatchToProps = {
  toggleBatchNavMenu,
  getBatchMenuData,
  addSelectionToBatch: addFulfillmentPlansOrSalesOrderToBatchRequest,
  save: createBatchWithFulfillmentPlans,
  loadMore: loadMoreActiveBatches,
};

export const OrdersPageAddBatchMenuContainer = connect(mapStateToProps, mapDispatchToProps)(AddToBatchMenu);
